module.exports = __webpack_public_path__ + "d12c3494336a7de68c0335127966e6f1.png";